import { render, staticRenderFns } from "./SchoolChange.vue?vue&type=template&id=2b14beec&scoped=true&"
import script from "./SchoolChange.vue?vue&type=script&lang=js&"
export * from "./SchoolChange.vue?vue&type=script&lang=js&"
import style0 from "./SchoolChange.vue?vue&type=style&index=0&id=2b14beec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b14beec",
  null
  
)

export default component.exports